// extracted by mini-css-extract-plugin
export default {"card":"DashboardCardShell_card__lm1oG"};